const apiUrl = process.env.REACT_APP_API_URL;
export const PostComandaIngredient = async (page: string, comandaIngredient: any[], id_comanda: number, id_usu_log: string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comanda/ingredient/${id_comanda}/${id_usu_log}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(comandaIngredient)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};